module.exports = __webpack_public_path__ + "img/send.bdd7ef0f.svg";